import React, { useCallback, useRef, useState } from "react";
import { detailtype } from "../../../interface/interface";
function FieldCard({
  index,
  data,
  __update,
  __setopen,
  isOpen,
}: {
  index: number;
  data: detailtype;
  __update: (type: string, payload: any, index: number) => void;
  __setopen: (t: number | undefined) => void;
  isOpen: number | undefined;
}) {
  const cardRef = useRef<null | HTMLDivElement>(null);

  const __categoryChange = useCallback(
    (type: string) => {
      __update("detail/category", type, index);
      __setopen(undefined);
    },
    [__update, index]
  );

  const category =
    category_layout[data.rcrt_type_cd as keyof typeof category_layout];
  return data.IUD !== "D" ? (
    <div className="field-card" ref={cardRef}>
      <img
        src="/assets/common/cancel.svg"
        alt=""
        className="cancel"
        onClick={() => {
          __update("detail/remove", "", index);
        }}
      />
      <div className="left">
        <div className="title">모집 분야</div>
        <div className="input-wrapper">
          <input
            type="text"
            placeholder="예 )  UXUI 디자이너 / 서비스 기획자 /  백엔드 개발자"
            value={data.rcrt_nm}
            onChange={(e) => {
              if (e.target.value.length < 26) {
                __update("detail/title", e.target.value, index);
              }
            }}
          />
          <div className="length">{data.rcrt_nm.length}/25</div>
        </div>
      </div>
      <div className="right">
        <div className="title">카테고리</div>
        <div
          className={`category-wrapper ${isOpen === index ? "open-list" : ""}`}
          tabIndex={-1}
        >
          <div
            className="now-category"
            onClick={() => {
              __setopen(isOpen === index ? undefined : index);
            }}
            tabIndex={-1}
          >
            <div className="placeholder">
              {data.rcrt_type_cd ? (
                <>
                  <img
                    src={`/assets/project/${data.rcrt_type_cd}.svg`}
                    alt=""
                  />
                  <div className="title">{category}</div>
                </>
              ) : (
                "카테고리 선택"
              )}
            </div>
            <img src="/assets/project/grey-arrow.svg" alt="" />
          </div>
          <div className={`category-list`}>
            {arr.map(({ title, type }, idx) => {
              return (
                <button
                  key={idx}
                  className="category-btn"
                  onClick={() => {
                    __categoryChange(type);
                  }}
                  tabIndex={-1}
                >
                  <img src={`/assets/project/${type}.svg`} alt="" />
                  <div className="title">{title}</div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
      <div className="left">
        <div className="title">설명</div>
        <div className="input-wrapper">
          <input
            type="text"
            placeholder="예 ) 데이터분석 언어로 R + 파이썬 경험 필요 + 중급이상의 기본기 필요"
            value={data.rcrt_ctts}
            onChange={(e) => {
              if (e.target.value.length < 65) {
                __update("detail/sub", e.target.value, index);
              }
            }}
          />
          <div className="length">{data.rcrt_ctts.length}/64</div>
        </div>
      </div>
      <div className="right">
        <div className="title">모집 인원</div>
        <div className="input-wrapper">
          <input
            type="number"
            placeholder="숫자를 입력해주세요"
            value={data.rcrt_usr_cnt}
            onChange={(e) => {
              __update(
                "detail/num",
                e.target.value ? parseFloat(e.target.value) : "",
                index
              );
            }}
          />
          <div className="length">명</div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}

export default FieldCard;

const category_layout = {
  design: "디자인",
  media: "미디어/영상",
  dev: "개발",
  marketing: "마케팅",
  service: "서비스",
  plan: "기획",
  art: "예술",
  all: "기타",
};

const arr = [
  { type: "design", title: "디자인" },
  { type: "media", title: "미디어/영상" },
  { type: "dev", title: "개발" },
  { type: "marketing", title: "마케팅" },
  { type: "service", title: "서비스" },
  { type: "plan", title: "기획" },
  { type: "art", title: "에술" },
  { type: "all", title: "기타" },
];
